import React, { useState } from "react";
import {
    Badge,
    Modal,
    ModalHeader,
    ModalBody,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Row,
    Col
} from "reactstrap";
import { FILES_URL, BASE_URL } from "helpers/url_helper";
import EmployeeFilesModal from "./EmployeeFilesModal";
import formatDate from "constants/formatDate";

const UserDetailRow = ({ user, onEdit, onDelete, reloadData }) => {
    const [filesModalOpen, setFilesModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState("driver");

    const toggleFilesModal = () => setFilesModalOpen(!filesModalOpen);

    const handleOpenFile = (type, fileId) => {
        try {
            const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
            const token = authUser?.token || "";

            const url = `${BASE_URL}/users/signed-files/${type}/${fileId}/${token}`;
            window.open(url, "_blank", "noopener");
        } catch (e) {
            console.error("Failed to open file", e);
        }
    };

    const renderFileCard = (file, title, extraLines = [], fileType) => (
        <Col md={3} sm={4} xs={6} key={`${title}_${file.id}`} className="mb-4">
            <div
                className="text-center"
                style={{ cursor: "pointer" }}
                onClick={() => handleOpenFile(fileType, file.id)}
            >
                <div style={{ fontSize: 40, marginBottom: 8 }}>
                    <i className="bx bxs-file-blank text-primary" />
                </div>
                <div style={{ fontWeight: 600, fontSize: 13 }}>{title}</div>
                {extraLines
                    .filter(Boolean)
                    .map((line, idx) => (
                        <div key={idx} style={{ fontSize: 11, color: "#666" }}>
                            {line}
                        </div>
                    ))}
            </div>
        </Col>
    );

    return (
        <>
            <tr>
                <td>
                    <img
                        src={
                            user.picture
                                ? FILES_URL + user.picture
                                : "https://placehold.co/50"
                        }
                        alt="pic"
                        height={40}
                        style={{ borderRadius: 6 }}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "https://placehold.co/50";
                        }}
                    />
                </td>

                <td>{user.full_name}</td>
                <td>{user.email}</td>

                <td>
                    <Badge
                        className={
                            user.role === "admin"
                                ? "bg-success"
                                : user.role === "account_manager"
                                    ? "bg-info"
                                    : "bg-danger"
                        }
                        style={{ padding: "6px 10px" }}
                    >
                        {user.role}
                    </Badge>
                </td>

                <td>{formatDate(user.created_at)}</td>

                <td className="text-center">
                    <i
                        className="bx bx-file text-warning me-2"
                        style={{ fontSize: 16, cursor: "pointer" }}
                        onClick={() => {
                            setActiveTab("driver");
                            setFilesModalOpen(true);
                        }}
                    ></i>

                    <i
                        className="bx bx-pencil text-info me-2"
                        style={{ fontSize: 16, cursor: "pointer" }}
                        onClick={() => onEdit(user)}
                    ></i>

                    <i
                        className="bx bx-trash text-danger"
                        style={{ fontSize: 16, cursor: "pointer" }}
                        onClick={() => {
                            if (
                                window.confirm(
                                    `Are you sure to delete ${user.full_name}?`
                                )
                            ) {
                                onDelete(user.id);
                            }
                        }}
                    ></i>
                </td>
            </tr>

            <EmployeeFilesModal
                user={user}
                isOpen={filesModalOpen}
                toggle={toggleFilesModal}
                reloadData={reloadData}
            />

        </>
    );
};

export default UserDetailRow;
